/** Conservation des dossiers de « Prouver » (lot 5, valide par Franck le
 *  07/10/2026) : le client choisit UNE fois ce qui se passe a l'echeance ;
 *  son choix vaut pour tous ses dossiers jusqu'a ce qu'il le change. */
import { useEffect, useState } from "react";

import { api, type ConservationProuver as Reglages } from "../api";
import { Erreur, montant } from "../components/ui";

export function ConservationProuver() {
  const [reglages, setReglages] = useState<Reglages | null>(null);
  const [enCours, setEnCours] = useState(false);
  const [erreur, setErreur] = useState<unknown>(null);

  useEffect(() => {
    api.conservationProuver().then(setReglages, setErreur);
  }, []);

  const choisir = async (auto: boolean) => {
    setEnCours(true);
    setErreur(null);
    try {
      setReglages(await api.choisirConservation(auto));
    } catch (e) {
      setErreur(e);
    } finally {
      setEnCours(false);
    }
  };

  if (!reglages) return <Erreur erreur={erreur} />;
  const duree = reglages.conservation_mois % 12 === 0
    ? `${reglages.conservation_mois / 12} an(s)` : `${reglages.conservation_mois} mois`;

  return (
    <div className="card stack" style={{ marginBottom: "1.5rem" }}>
      <h2 className="card__title" style={{ fontSize: "1.1rem" }}>Prouver · Conservation des dossiers</h2>
      <p className="muted" style={{ margin: 0 }}>
        Chaque dossier est conservé {duree} après son envoi, sous un verrou qui en interdit la suppression.
        Téléchargez vos Journaux de preuve et gardez-les : passé l'échéance, leur conservation par Sign365
        n'est plus garantie. Un e-mail mensuel vous annonce les dossiers qui arrivent à échéance le mois suivant.
      </p>
      <fieldset className="field" disabled={enCours} style={{ border: 0, padding: 0, margin: 0 }}>
        <legend className="field-label">À l'échéance</legend>
        <label style={{ display: "block" }}>
          <input type="radio" name="pe-echeance" checked={reglages.prolongation_auto}
                 onChange={() => void choisir(true)} />{" "}
          Prolonger automatiquement de {duree}, pour {montant(reglages.prix_prolongation_minor, "EUR")} par
          dossier, débités de votre crédit
        </label>
        <label style={{ display: "block" }}>
          <input type="radio" name="pe-echeance" checked={!reglages.prolongation_auto}
                 onChange={() => void choisir(false)} />{" "}
          Laisser expirer
        </label>
      </fieldset>
      <Erreur erreur={erreur} />
    </div>
  );
}
